<template>
  <b-container class="main-content help-page">
    <div class="row-main">
    <h1>Hilfe</h1>
    <p> Auf dieser Seite finden Sie Hilfe zum Umgang mit fairvote.ch. <br>
      Hilfe erhalten Sie auch von <icon icon="robot" />-Chatty oder per Telefonsupport</p>
    </div>
    <div class="row-main">
      <p> Im folgenden Video erhalten Sie einen Überblick über die Funktionen von fairvote.ch</p>
      <div class="row justify-content-center">
      <iframe style="width: 70%;" width="700" height="500" src="https://www.youtube.com/embed/dRRm6GWUM8k"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
      </div>
    </div>
    <div   class="row-main">
      <h1>Themengebiete</h1>
      <p> Zu den folgenden Themen gibt es eine eigene Infoseite mit Erklärungen und Video-Anleitungen.
      </p>
    <div class="row justify-content-center">
      <b-card-group deck>
      <b-card
        title="Login"
        img-src="@/assets/img/login-icon.jpg"
        img-alt="Login-Image"
        img-top
        tag="article"
        style="max-width: 20rem;"
        class="mb-2">
        <b-card-text>
          Hier finden Sie Anleitungen und Hilfestellungen rund ums Thema Login.
        </b-card-text>

        <b-button href="#" variant="primary">mehr</b-button>
      </b-card>

      <b-card
        title="Stimmabgabe"
        img-src="@/assets/img/vote-icon.jpg"
        img-alt="Login-Image"
        img-top
        tag="article"
        style="max-width: 20rem;"
        class="mb-2">
        <b-card-text>
          Hier finden Sie Informationen und Anleitungen zur Stimmabgabe.
        </b-card-text>

        <b-button href="#" variant="primary">mehr</b-button>
      </b-card>
      <b-card
        title="Sicherheit"
        img-src="@/assets/img/security-icon.jpg"
        img-alt="Login-Image"
        img-top
        tag="article"
        style="max-width: 20rem;"
        class="mb-2">
        <b-card-text>
          Hier finden Sie Wissenswertes rund ums Thema Sicherheit.
        </b-card-text>

        <b-button href="#" variant="primary">mehr</b-button>
      </b-card>
        </b-card-group>
    </div>
    </div>

    <div class="row-main">
      <h1><icon icon="robot" /> Support</h1>
      <p>Chatty, der interaktive Chatbot von fairvote, kann ihnen bestimmt weiterhelfen<br>
      Gerne können Sie auch einen unserer Support Mitarbeiter anrufen</p>


    <div class="row justify-content-center">
      <b-card-group>
        <b-card title="" img-src="@/assets/img/chatty-icon.jpg" img-alt="Image" img-top>
          <b-card-text>
            <b-button href="https://botpreview.com/p/d36dcb26-5225-4217-8d82-b949fb09a94e" target="_blank" variant="primary">Hallo <icon icon="robot" /> </b-button>
          </b-card-text>
        </b-card>

        <b-card title="" img-src="@/assets/img/callcenter-icon.jpg" img-alt="Image" img-top>
          <b-card-text>
            <b-button href="https://mms.migros.net/invited.sf?secret=YwRQ2hVpWjwPshBkiQ4POA&id=465397619" target="_blank" variant="primary">Telefonsupport</b-button>
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>
    </div>

    </div>
  </b-container>
</template>

<script>
export default {
  name: 'Help.vue',
};
</script>

<style scoped>
  .row justify-content-center chatty{
    padding-top: 10px;
  }
  .row-main {
    margin-top: 50px;
    margin-bottom: 50px;
    padding-bottom: 20px;
    border-bottom: #775353 solid 1px;
  }

</style>
